import React from 'react';

const s = {
  section: {
    padding: '100px 0',
    background: 'linear-gradient(180deg, #080d20, #050815)',
    position: 'relative',
  },
  container: { maxWidth: 1100, margin: '0 auto', padding: '0 24px' },
  header: { textAlign: 'center', marginBottom: 60 },
  tag: {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    background: 'rgba(108,99,255,0.1)', border: '1px solid rgba(108,99,255,0.25)',
    borderRadius: 100, padding: '5px 14px',
    fontSize: 11, fontFamily: 'Sora, sans-serif', fontWeight: 500,
    color: '#a5a0ff', marginBottom: 20,
  },
  h2: { fontFamily: 'Sora, sans-serif', fontSize: 40, fontWeight: 800, marginBottom: 14 },
  purple: {
    background: 'linear-gradient(135deg, #6c63ff, #818cf8)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
  },
  subtext: {
    color: '#8892b0', fontSize: 15, fontFamily: 'DM Sans, sans-serif', lineHeight: 1.7,
  },
  bold: { color: '#f0f4ff', fontWeight: 600 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, alignItems: 'start' },
  card: {
    background: 'rgba(13,18,41,0.8)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 18, padding: 32, position: 'relative',
    transition: 'all 0.3s ease',
  },
  cardFeatured: {
    background: 'rgba(108,99,255,0.08)',
    border: '1px solid rgba(108,99,255,0.4)',
    borderRadius: 18, padding: 32, position: 'relative',
    boxShadow: '0 0 40px rgba(108,99,255,0.15)',
  },
  popularBadge: {
    position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    borderRadius: 100, padding: '4px 16px',
    fontSize: 11, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    color: '#fff', whiteSpace: 'nowrap',
  },
  planName: { fontFamily: 'Sora, sans-serif', fontSize: 18, fontWeight: 700, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 },
  price: { display: 'flex', alignItems: 'baseline', gap: 2, margin: '20px 0 6px' },
  priceCurrency: { fontSize: 18, color: '#6c63ff', fontFamily: 'Sora, sans-serif', fontWeight: 600 },
  priceNum: { fontSize: 52, fontFamily: 'Sora, sans-serif', fontWeight: 800, lineHeight: 1 },
  pricePer: { fontSize: 14, color: '#8892b0', fontFamily: 'DM Sans, sans-serif' },
  planDesc: { fontSize: 13, color: '#8892b0', marginBottom: 24, fontFamily: 'DM Sans, sans-serif', lineHeight: 1.6, minHeight: 40 },
  btnOutline: {
    width: '100%', padding: '12px 0', borderRadius: 10,
    background: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
    color: '#f0f4ff', fontSize: 14, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.2s', marginBottom: 24,
  },
  btnFilled: {
    width: '100%', padding: '12px 0', borderRadius: 10,
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    border: 'none', color: '#fff',
    fontSize: 14, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.2s', marginBottom: 24,
    boxShadow: '0 6px 20px rgba(108,99,255,0.4)',
  },
  divider: { height: 1, background: 'rgba(255,255,255,0.06)', marginBottom: 20 },
  featureList: { display: 'flex', flexDirection: 'column', gap: 11 },
  featureItem: { display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, fontFamily: 'DM Sans, sans-serif' },
  checkOn: { color: '#22c55e', flexShrink: 0, fontSize: 14 },
  checkOff: { color: '#4a5568', flexShrink: 0, fontSize: 14 },
  featureOn: { color: '#c0c8e0' },
  featureOff: { color: '#4a5568', textDecoration: 'line-through' },
  custom: {
    marginTop: 32,
    background: 'rgba(13,18,41,0.6)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 16, padding: '36px 40px',
    textAlign: 'center',
  },
  customTitle: { fontFamily: 'Sora, sans-serif', fontSize: 22, fontWeight: 700, marginBottom: 10 },
  customDesc: { color: '#8892b0', fontSize: 14, fontFamily: 'DM Sans, sans-serif', marginBottom: 24, maxWidth: 500, margin: '0 auto 24px' },
  customBtn: {
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    border: 'none', color: '#fff', padding: '12px 32px',
    borderRadius: 10, fontSize: 14, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    cursor: 'pointer', boxShadow: '0 6px 20px rgba(108,99,255,0.35)',
    transition: 'all 0.2s',
  },
};

const plans = [
  {
    name: 'Básico', icon: '⚡', price: 29, featured: false,
    desc: 'Ideal para pequeñas empresas que inician su transformación digital.',
    features: [
      [true, 'Hasta 5 usuarios'],
      [true, '1 empresa'],
      [true, '50 GB de almacenamiento'],
      [true, 'Control de versiones (30 días)'],
      [true, 'Permisos básicos por archivo'],
      [true, 'Comentarios en archivos'],
      [true, 'Soporte por correo electrónico'],
      [false, 'Soporte multi-empresa'],
      [false, 'Acceso a API'],
      [false, 'Soporte prioritario 24/7'],
    ],
  },
  {
    name: 'Profesional', icon: '🏢', price: 89, featured: true,
    desc: 'Para empresas en crecimiento que necesitan más control y colaboración.',
    features: [
      [true, 'Hasta 25 usuarios'],
      [true, 'Hasta 3 empresas'],
      [true, '500 GB de almacenamiento'],
      [true, 'Control de versiones (1 año)'],
      [true, 'Permisos granulares avanzados'],
      [true, 'Comentarios y respuestas anidadas'],
      [true, 'Soporte por correo y chat en vivo'],
      [true, 'Soporte multi-empresa'],
      [true, 'Acceso a API'],
      [false, 'Soporte prioritario 24/7'],
    ],
  },
  {
    name: 'Empresarial', icon: '👑', price: 249, featured: false,
    desc: 'Solución completa para grandes corporaciones con necesidades avanzadas.',
    features: [
      [true, 'Usuarios ilimitados'],
      [true, 'Empresas ilimitadas'],
      [true, 'Almacenamiento ilimitado'],
      [true, 'Control de versiones ilimitado'],
      [true, 'Permisos granulares avanzados'],
      [true, 'Comentarios y respuestas anidadas'],
      [true, 'Gerente de cuenta dedicado'],
      [true, 'Soporte multi-empresa'],
      [true, 'Acceso completo a API'],
      [true, 'Soporte prioritario 24/7'],
    ],
  },
];

export default function Pricing() {
  return (
    <section style={s.section} id="precios">
      <div style={s.container}>
        <div style={s.header}>
          <div style={s.tag}>👑 Planes y Precios</div>
          <h2 style={s.h2}>Elige el plan <span style={s.purple}>perfecto para tu empresa</span></h2>
          <p style={s.subtext}>
            Sin contratos a largo plazo. Cancela cuando quieras. Todos los planes incluyen{' '}
            <strong style={s.bold}>14 días de prueba gratuita</strong> sin tarjeta de crédito.
          </p>
        </div>

        <div style={s.grid}>
          {plans.map((plan) => (
            <div key={plan.name} style={plan.featured ? s.cardFeatured : s.card}
              onMouseEnter={e => { if (!plan.featured) { e.currentTarget.style.borderColor = 'rgba(108,99,255,0.3)'; e.currentTarget.style.transform = 'translateY(-4px)'; } }}
              onMouseLeave={e => { if (!plan.featured) { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.transform = 'translateY(0)'; } }}
            >
              {plan.featured && <div style={s.popularBadge}>⭐ Más Popular</div>}
              <div style={s.planName}>{plan.icon} {plan.name}</div>
              <div style={s.price}>
                <span style={s.priceCurrency}>$</span>
                <span style={s.priceNum}>{plan.price}</span>
                <span style={s.pricePer}>/mes</span>
              </div>
              <p style={s.planDesc}>{plan.desc}</p>
              <button
                style={plan.featured ? s.btnFilled : s.btnOutline}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
              >
                Comenzar ahora
              </button>
              <div style={s.divider} />
              <div style={s.featureList}>
                {plan.features.map(([on, text]) => (
                  <div key={text} style={s.featureItem}>
                    <span style={on ? s.checkOn : s.checkOff}>{on ? '✓' : '✗'}</span>
                    <span style={on ? s.featureOn : s.featureOff}>{text}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={s.custom}>
          <div style={s.customTitle}>¿Necesitas una solución personalizada?</div>
          <p style={s.customDesc}>
            Ofrecemos implementaciones en sitio (on-premise), integraciones personalizadas y contratos
            corporativos adaptados a las necesidades específicas de tu organización.
          </p>
          <button style={s.customBtn}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Hablar con el equipo de ventas
          </button>
        </div>
      </div>
    </section>
  );
}
